import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=7da34f7a&scoped=true&"
import script from "./IconDownload.vue?vue&type=script&lang=js&"
export * from "./IconDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da34f7a",
  null
  
)

export default component.exports